import React from 'react';
const ErrorComponent = (props) => {
        return (
        props.pageData && props.pageData.data && props.pageData.data.errorPage ?
        <div className="errorPanel" >            
                <h3 className="sub-title">
                    { props.pageData.data.errorPage.header }
                    </h3>
                <div className="text-justify">
                    <p>{ props.pageData.data.errorPage.message1 }<br/>
                       { props.pageData.data.errorPage.message2 }
                    </p>
                    <p>
                       { props.pageData.data.errorPage.message3 }<br/>
                       { props.pageData.data.errorPage.message4 }<br/>
                       { props.pageData.data.errorPage.message5 }<br/>
                       { props.pageData.data.errorPage.message6 }
                    </p>
                    <p>
                       { props.pageData.data.errorPage.message7 }<br/>
                       { props.pageData.data.errorPage.message8 }<br/>
                       { props.pageData.data.errorPage.message9 }
                    </p>
					
                </div>
            </div>
            : ''
    );
};

export default ErrorComponent;